export default __webpack_public_path__ + "static/media/box-3Open.71193899.jpg";